import { EmployeeController, PayrollController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import { useFileUpload } from 'use-file-upload';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { AddSalesSheet } from '../../pages/Payroll';

const UploadSalesSheetContainer = ({ closeModal }) => {
	const [loading, setLoading] = useState(false);
	const [uploaded, setUploaded] = useState(false);
	const [file, selectFile] = useFileUpload();

	const selectClick = () => {
		selectFile({ accept: '.xlsx' });
	};

	return (
		<AddSalesSheet
			closeModal={closeModal}
			uploaded={uploaded}
			file={file}
			selectClick={selectClick}
			loading={loading}
		/>
	);
};

export default observer(UploadSalesSheetContainer);
